import React, { useContext, useEffect, useState } from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import styles from './Hero.module.sass'
import Icon from '../../../components/Icon'
import Player from '../../../components/Player'
import { toUsd } from '../../../adapters/eth'
import { fromWei } from 'web3-utils'
import PlaceABid from '../../../components/PlaceABid'
import { ReactVideo } from 'reactjs-media'
import { Web3Context } from '../../../contexts/Web3Context'
import config from '../../../config'

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
)

const Hero = ({ items, users }) => {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14"/>
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14"/>
      </SlickArrow>
    ),
    afterChange: (i) => setToken(nft[i]),
  }

  const [nft, setNft] = useState([])
  const [token, setToken] = useState()

  const { rate } = useContext(Web3Context)

  useEffect(() => {
    items = items.map(i => {
      i.creator = users[i?.owners?.[0]?.owner] ?? users[i.creator] ?? i.creator
      return i
    })
    setNft(items)
    setToken(items[0])
  }, [items])

  return (
    <>
      <div className={cn('section', styles.section)}>
        <div className={cn('container', styles.container)}>
          <div className={styles.hero_video}>

            {process.env.REACT_APP_SHOW_MAIN_VIDEO === 'true' &&
            <ReactVideo
              src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/splash.mp4'}
              poster={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/splash-poster.jpg'}
              primaryColor="red"
              type="video/mp4"
              autoPlay={false}
              className="nftVideo"
            />
            }

            {process.env.REACT_APP_SHOW_MAIN_VIDEO !== 'true' &&
            <img
              src={'/themes/' + process.env.REACT_APP_THEME_IMAGE_FOLDER + '/splash.jpg'}
              alt={process.env.REACT_APP_TITLE}
            />
            }

          </div>
          <div className={styles.head}>
            <Link className={cn('button-full', styles.button)} to="/search">
              Start your search
            </Link>
          </div>
          <div className={styles.wrapper}>
            <Slider className="creative-slider" {...settings}>
              {nft && nft.map((x, index) => (
                <div className={styles.slide} key={index}>
                  <div className={styles.row}>
                    <Player className={styles.player} item={x}/>
                    <div className={styles.details}>
                      <div className={cn('h1', styles.subtitle)}>{x.name}</div>
                      <div className={styles.line}>
                        <div className={styles.item}>
                          <div className={styles.avatar}>
                            <img src={x.creator.avatar} alt="Avatar"/>
                          </div>
                          <div className={styles.description}>
                            <div className={styles.category}>Creator</div>
                            <div className={styles.text}>{x.creator.username}</div>
                          </div>
                        </div>
                        <div className={styles.item}>
                          <div className={styles.icon}>
                            <Icon name="stop" size="24"/>
                          </div>
                          <div className={styles.description}>
                            <div className={styles.category}>Sell price</div>
                            <div className={styles.text}>
                              {fromWei(x.price ?? '0', 'ether')}&nbsp;{config.symbolName}
                              &nbsp;(${toUsd(x.price ?? '0', rate)})
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.wrap}>
                        <div className={styles.info}>Buyout price</div>
                        <div
                          className={styles.currency}>{fromWei(x.price ?? '0', 'ether')}&nbsp;{config.symbolName}</div>
                        <div className={styles.price}>${toUsd(x.price ?? '0', rate)}</div>
                      </div>
                      <div className={styles.btns}>
                        <PlaceABid item={token} users={users}/>
                        <Link className={cn('button-stroke', styles.button)} to={'/item/' + x.seo_url}>
                          View item
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  )
}

export default Hero
